import "./App.css";
import React from "react";
import Main from "./containers/Main";

var App = () => {
  return (
    <div>
      <Main />
    </div>
  );
};

export default App;
